namespace $ { $mol_style_attach( "mol/map/yandex/yandex.view.css",
 "[mol_map_yandex] {\n\tflex: auto;\n\talign-self: stretch;\n\tfilter: var(--mol_theme_image);\n}\n"
) }